/**
 * store/modules/admin/adminAssetType.js
 *
 * Vuex module handling admin-asset-type state and actions.
 */
import axios from 'axios'

export default {
  // admin-asset-type state.
  state: {
    assetTypeList: [],
    assetType: {},
  },

  // Mutations to alter admin-asset-type state.
  mutations: {
    setAssetType: (state, assetType) => (state.assetType = assetType),
    setAssetTypeList: (state, assetTypeList) => (state.assetTypeList = assetTypeList),
  },

  // Actions handling requests, and committing mutations.
  actions: {
    // Get type list.
    async getAssetTypes ({ commit }) {
      try {
        let response = await axios.get('/api/admin/asset-type')
        // Got an asset-type-listing, commit that to state.
        commit('setAssetTypeList', response.data)
      } catch (err) {
        console.error('Unable to fetch asset-types.')
      }
    },

    // Get a single type by ID.
    async getAssetType ({ commit }, assetTypeId) {
      try {
        let response = await axios.get('/api/admin/asset-type/' + assetTypeId)
        // Got an asset-type, commit that to state.
        commit('setAssetType', response.data)
      } catch (err) {
        console.error('Unable to fetch asset-type: ', assetTypeId)
      }
    },

    // Create a type, pass in assetType JSON obj.
    async createAssetTypes ({ commit, dispatch }, assetType) {
      try {
        let response = await axios.post('/api/admin/asset-type', assetType)
        // Success in type creation, set state to this type from res.
        commit('setAssetType', response.data)
        // Refresh the type list.
        dispatch('getAssetTypes')
      } catch (err) {
        console.error('Unable to create asset-type.')
      }
    },

    // Update a type by ID.
    async updateAssetType ({ commit, dispatch }, assetType) {
      try {
        let response = await axios.put('/api/admin/asset-type/' + assetType.id, assetType)
        // Update the asset type in state.
        commit('setAssetType', response.data)
        // Update the list.
        dispatch('getAssetTypes')
      } catch (err) {
        console.error('Unable to update asset-type: ', assetType.id)
      }
    },

    // Delete a type by ID.
    async deleteAssetType ({ commit, dispatch }, assetTypeId) {
      try {
        await axios.delete('/api/admin/asset-type/' + assetTypeId)
        // Remove any asset type in state.
        commit('setAssetType', {})
        // Update the list.
        dispatch('getAssetTypes')
      } catch (err) {
        console.error('Unable to delete asset-type: ', assetTypeId)
      }
    },

  },

  // User state getters.
  getters: {
    adminAssetTypeList: state => state.assetTypeList,
    adminAssetType: state => state.assetType,
  }
}
